<template>
  <q-card flat>
    <q-card-section class="no-padding" v-if="isDialog">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>انتخاب مشتری</span>
        <template v-slot:action>
          <q-btn round icon="close" v-close-popup flat padding="none"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-input readonly
               v-if="selectedCustomer === undefined"
               v-model="selectedCustomer" filled
               :label="buyList?'عنوان تامین کننده':'عنوان مشتری'">
        <template v-slot:append>
          <q-btn icon="info" @click="customerProfileDialog=true" round flat v-if="selectedCustomer">
            <q-tooltip>
              پروفایل مشتری
            </q-tooltip>
          </q-btn>
          <q-btn icon="check_circle" round flat
                 @click="customerDialog=true">
            <q-tooltip>
              <span v-if="!title">{{ buyList ? 'انتخاب تامین کننده' : 'انتخاب مشتری' }}</span>
              <span v-if="title">{{ title }}</span>
            </q-tooltip>
          </q-btn>
          <q-btn icon="cancel" round flat @click="clearSelectedCustomer" v-if="selectedCustomer"/>
        </template>
      </q-input>
    </q-card-section>

    <q-dialog maximized v-model="customerDialog" persistent>
      <q-card flat>
        <q-card-section class="no-padding">
          <q-banner class="bg-blue text-white" inline-actions>
            <span v-if="!title">{{ buyList ? 'انتخاب تامین کننده' : 'انتخاب مشتری' }}</span>
            <span v-if="title">{{ title }}</span>
            <template v-slot:action>
              <q-btn icon="close" round flat v-close-popup/>
            </template>
          </q-banner>
        </q-card-section>
        <q-card-section class="no-padding">
          <CustomerSearchPanel :buy-list="buyList"/>
          <CustomersList
              @customerSelected="customerSelected"
              :buy-list="buyList"
              :is-dialog="false"
              :items="[]"
              :is-only-search-list="false"/>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog :maximized="$q.screen.lt.md" v-model="customerProfileDialog">
      <CustomerInfo :selected-customer="selectedCustomer" v-if="selectedCustomer!=null" :buy-list="true"
                    :dialog="true"/>
    </q-dialog>
  </q-card>
</template>

<script>
import CustomerSearchPanel from "@/components/customers/CustomerSearchPanel";
import {mapActions} from "vuex";
import CustomersList from "@/components/customers/CustomersList";
import CustomerInfo from "@/components/customers/CustomerInfo";

export default {
  name: "SelectCustomer",
  components: {CustomerInfo, CustomersList, CustomerSearchPanel},
  props: {
    selectedCustomer: {
      type: Object,
      default: undefined
    },
    buyList: {
      type: Boolean,
      required: false,
      default: true
    },
    title: {
      type: String
    },
    isDialog: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      customerDialog: false,
      localSelectedCustomer: this.selectedCustomer,
      selectedCustomerName: undefined,
      customerProfileDialog: false,
    }
  },
  methods: {
    ...mapActions({}),
    customerSelected(args) {
      this.selectedCustomerName = `${args.Cs_ShopName} (${args.Cs_Name})`
      this.localSelectedCustomer = args
      this.customerDialog = false
      this.$emit('customerSelected', args)
    },
    clearSelectedCustomer() {
      this.selectedCustomerName = undefined
      this.localSelectedCustomer = undefined
      this.$emit('customerSelected', undefined)
    }
  },
  created() {
    if (this.selectedCustomer !== undefined) {
      this.localSelectedCustomer = this.selectedCustomer
      this.selectedCustomerName = `${this.selectedCustomer.Cs_ShopName} (${this.selectedCustomer.Cs_Name})`
    }
  }
}
</script>

<style scoped>

</style>